<template>
  <div class="cooperation" id="partners">
    <div class="cooperation_wrap">
      <div class="cooperation_tit">合作伙伴</div>
      <div class="cooperation_box">
        <div
          :class="['cooperation_item', { active: activeIndex === item.id }]"
          v-for="(item, index) in tabList"
          :key="index"
          @click="toggle(item.id)"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
    <div class="cooperation_bottom">
      <div class="cooperation_wrap">
        <a v-for="item in logoList" :key="item.id" :href="item.url" target="_blank">
          <img class="logo_item" :src="item.image" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
export default {
  data() {
    return {
      activeIndex: 1,
      tabList: [],
      logoList: [],
    };
  },
  created() {
    this.getTypeList();
  },
  methods: {
    async getTypeList() {
      const res = await CifuAPI.getLinkType();
      if (res.code === 1) {
        this.activeIndex = res.data[0].id;
        this.tabList = res.data;
        this.getLogoList();
      }
    },
    async getLogoList() {
      const res = await CifuAPI.getLinkList({ type_id: this.activeIndex });
      if (res.code === 1) {
        this.logoList = res.data;
      }
    },
    toggle(index) {
      this.activeIndex = index;
      this.getLogoList();
    },
  },
};
</script>

<style lang="scss" scoped>
.cooperation {
  width: 100%;
  padding-top: 94px;
  background-color: #fff;
  min-width: 1200px; // 设置合理的固定宽度，防止过度缩小
  // 处理浏览器放大后的情况
  @media screen and (min-width: 1201px) {
    min-width: auto; // 1200px以上恢复完全响应式
  }  
  @media screen and (max-width: 1200px) {
    min-width: 1200px; // 1200px以下固定宽度，不再缩小
  // 处理浏览器放大后的情况
  @media screen and (min-width: 1201px) {
    min-width: auto; // 1200px以上恢复完全响应式
  }  }
  
  // 只在真正的移动设备上应用移动端样式
  // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
  //   padding: 20px 10px;
  //   min-width: auto; // 移动端不限制最小宽度
  // }
  
  // 处理浏览器放大后的情况
  @media screen and (min-width: 1421px) {
    min-width: auto; // 1200px以上恢复完全响应式
  }
  
  &_wrap {
    display: flex;
    width: 1200px;
    gap: 50px;
    flex-wrap: wrap;
    margin: 0 auto;
    min-width: 1200px; // 设置合理的固定宽度，防止过度缩小
  // 处理浏览器放大后的情况
  @media screen and (min-width: 4) {
    min-width: auto; // 1200px以上恢复完全响应式
  }    
    @media screen and (max-width: 1200px) {
      min-width: 1200px; // 1200px以下固定宽度，不再缩小
  // 处理浏览器放大后的情况
  @media screen and (min-width: 1201px) {
    min-width: auto; // 1200px以上恢复完全响应式
  }    }
    
    // 只在真正的移动设备上应用移动端样式
    // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    //   padding: 0 10px;
    //   width: 100%;
    //   gap: 10px;
    //   min-width: auto; // 移动端不限制最小宽度
    // }
    
    // 处理浏览器放大后的情况
    @media screen and (min-width: 1201px) {
      min-width: auto; // 1200px以上恢复完全响应式
    }
  }
  &_tit {
    line-height: 60px;
    font-size: 52px;
    color: #663301;
    padding-bottom: 40px;
    // @media screen and (max-width: 768px) {
    //   padding-bottom: 0;
    //   font-size: 1.2rem;
    // }
  }
  &_box {
    display: flex;
    width: 100%;
    margin-bottom: 40px;
    // @media screen and (max-width: 768px) {
    //   margin-bottom: 20px;
    //   overflow-x: auto;
    // }
    .change_page {
      position: absolute;
      bottom: 40px;
      right: 40px;
      // @media screen and (max-width: 768px) {
      //   bottom: 5px;
      //   right: 5px;
      // }
    }
  }
  &_item {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 280px;
    height: 101px;
    border-bottom: 3px solid #e0e0e0;
    font-size: 18px;
    color: #4f4f4f;
    cursor: pointer;
    &.active {
      color: #663301;
      border-color: #fbce00;
    }
    // @media screen and (max-width: 768px) {
    //   width: auto;
    //   height: 60px;
    //   padding: 0 20px;
    //   white-space: nowrap;
    // }
  }
  &_bottom {
    width: 100%;
    padding: 54px 0;
    background-color: #f4f4f4;
    // @media screen and (max-width: 768px) {
    //   position: relative;
    //   z-index: 1;
    //   padding: 10px 0;
    //   &:after {
    //     position: absolute;
    //     right: -10px;
    //     top: 0;
    //     content: "";
    //     z-index: 2;
    //     width: 10px;
    //     height: 100%;
    //     background-color: #f4f4f4;
    //   }
    //   &:before {
    //     position: absolute;
    //     left: -10px;
    //     top: 0;
    //     content: "";
    //     z-index: 2;
    //     width: 10px;
    //     height: 100%;
    //     background-color: #f4f4f4;
    //   }
    // }
    a {
      display: inline-block;
      vertical-align: top;
    }
    .logo_item {
      width: 100px;
    }
  }
}
</style>
